export const config = {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  version: __APP_VERSION__,
  environment: import.meta.env.VITE_ENV,
  amplitudeKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  clarityKey: import.meta.env.VITE_CLARITY_KEY,
  authClientId: import.meta.env.VITE_AUTH_CLIENT_ID,
  awsWafApiKey: import.meta.env.VITE_AWS_WAF_API_KEY,
  apiHost: import.meta.env.VITE_API_HOST,
  onlineHost: import.meta.env.VITE_ONLINE_HOST,
  chatUrl: import.meta.env.VITE_CHAT_URL,
  chatWsUrl: import.meta.env.VITE_CHAT_WS_URL,
  chatProduct: import.meta.env.VITE_CHAT_PRODUCT,
  chatIntegratorName: import.meta.env.VITE_CHAT_INTEGRATOR_NAME,
  chatLocation: import.meta.env.VITE_CHAT_LOCATION,
  isMockingEnabled: import.meta.env.VITE_IS_MOCKING_ENABLED === 'true',
  isAmplitudeEnabled: import.meta.env.VITE_IS_AMPLITUDE_ENABLED === 'true',
  isTelemetryEnabled: import.meta.env.VITE_IS_TELEMETRY_ENABLED === 'true',
  growthBookApiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
  growthBookClientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
};

export type Config = typeof config;
